import React from 'react';

export default function ValueChangesCard({ title, description, data }) {
  const shouldShowImpact = data.some((v) => v.impact);
  const titles = {
    name: 'Property Name',
    current: 'Current Value',
    proposed: 'Proposed Value',
    impact: 'Impact',
  };

  const valueToString = (value) => {
    switch (typeof value) {
      case 'string':
        return value;
      case 'object':
        return value && value.join(', ');
      default:
        return value.toString();
    }
  };

  const row = (obj, isTitle = false) => {
    return (
      <div
        key={obj.name}
        className={`row ${isTitle ? 'bold' : 'values'}`}
      >
        <div className='column'>{obj.name}</div>
        <div className='column'>{valueToString(obj.current)}</div>
        <div className='column'>{valueToString(obj.proposed)}</div>
        {shouldShowImpact && (
          <div className={`one wide column ${!isTitle && 'impact'}`}>
            {obj.impact ? obj.impact : '0'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='ui fluid card'>
      <div className='content'>
        <div className='header'>{title}</div>
        <p className='meta'>{description}</p>
        <div
          className='ui divider'
          style={{ margin: 0 }}
        ></div>
        <div className='ui equal width grid properties'>
          {row(titles, true)}
          {data.map((v) => row(v))}
        </div>
      </div>
    </div>
  );
}
